module.exports = __webpack_public_path__ + "static/img/ai-home.1858207.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ai-home.jpg
// module id = ZdYx
// module chunks = 63